/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";

/*------------------------------------*\
    SLIDER SUBHEADING CAROUSEL
\*------------------------------------*/
class SliderSubheadingCarousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        this.carousel();
    }

    carousel() {
        let self = this;
        var slideIndex = 0;

        self.showSlides(slideIndex);
    }

    showSlides(slideIndex) {
        let self = this;

        var i;
        var slides = document.getElementsByClassName("slider__slide__subheading__carousel__item");

        for (i = 0; i < slides.length; i++) {
            slides[i].classList.remove('active');
        }

        slideIndex++;

        if (slideIndex > slides.length) {
            slideIndex = 1
        }

        slides[slideIndex-1].classList.add('active');;

        setTimeout(function() {
            self.showSlides(slideIndex);
        }, 5000)
    }
}

export default SliderSubheadingCarousel;
